import React, { useEffect } from 'react';
import InitialRouteScreen from './InitialRouteScreen';
import { getQueryParam } from '~/utils/helpers';
import useWebHistory from '~/hooks/useWebHistory';

export default function InitialRouteContainer(): JSX.Element {
    const history = useWebHistory();

    useEffect(() => {
        const activationCode = getQueryParam('code');

        if (activationCode) {
            history.push('/register/activate', { activationCode });
        }
    }, []);

    return <InitialRouteScreen />;
}
